import { EXPAND_CONTEXT } from './constants';

export type ExpandContextParams = {
  filepath: string;
  // TODO: remove prevFilepath — no longer consumed by expand-context-saga after preview-merge path was deleted
  prevFilepath?: string;
  fileIndex: number;
  expanderIndex: number;
  isShiftClicked: boolean;
  shouldExpandDown: boolean;
  selectedDiffSourceHash?: string;
};

export type ExpandContextAction = {
  type: string;
  payload: ExpandContextParams;
};

export const expandContext = (expandContextParams: ExpandContextParams) => ({
  type: EXPAND_CONTEXT.REQUEST,
  payload: expandContextParams,
});
